export default __webpack_public_path__ + "static/media/bathroom-sink.6944f664.svg";